module.exports = __webpack_public_path__ + "app/community/stock-software-detail-3NMJYI4s.html";